import { useLoadOrganizationStatsQuery } from "~/operations";
import { OrganizationScope, ScopeType, SpaceScope } from "~/hooks/useScope";
import { SelectOptions } from "~/types/form";

interface UseAssignSpacesToReposParams {
  scope: SpaceScope | OrganizationScope;
  repositories: {
    link: string;
    fullName: string;
  }[];
}

export function useAssignSpacesToRepos({
  scope,
  repositories,
}: UseAssignSpacesToReposParams) {
  const { data: orgStatsData } = useLoadOrganizationStatsQuery({
    variables: { mrn: scope?.mrn || "" },
    skip: scope.type !== ScopeType.Organization || !scope?.mrn,
  });

  const orgSpaces =
    orgStatsData?.organization?.spacesList.edges.flatMap((e) => e.node ?? []) ||
    [];

  const spaceOptions: SelectOptions<string> =
    orgSpaces.map(({ mrn, name }) => ({ value: mrn, label: name })) || [];

  const repositoriesOptions = repositories.map(({ link, fullName }) => ({
    value: link,
    label: fullName,
  }));

  return {
    spaceOptions,
    repositoriesOptions,
  };
}
